import { render } from "./ReportsStreamsPaid.vue?vue&type=template&id=fdaf3de2&scoped=true"
import script from "./ReportsStreamsPaid.vue?vue&type=script&lang=js"
export * from "./ReportsStreamsPaid.vue?vue&type=script&lang=js"

import "./ReportsStreamsPaid.vue?vue&type=style&index=0&id=fdaf3de2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdaf3de2"]])

export default __exports__